<template>
    <div>
        <div class="d-flex flex-column gap-2 question-container" v-for="(question,idx) in this.template.questions"
             :key="idx">
            <div>Question {{idx+1}}</div>
            <div>{{question['question']}}</div>
            <div class="d-flex gap-3">
                <div v-for="(a,index) in question.answers" class="d-flex gap-4">
                    <div class="m-c-answer-container d-flex gap-2">
                        <div>
                            <input :id="idx+'-'+index"
                                   type="checkbox"
                                   :value="a.value" v-model="a.is_correct" class="form-check-input"/>

                        </div>
                        <div class="d-flex align-items-center">{{ a.value}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'multipleChoices-component',
        data() {
            return {}
        },
        async mounted() {

        },
        props: ['template'],
        methods: {

        }
    }
</script>

<style scoped>
    .question-container {
        border-bottom: 1px solid #e65c00;
        margin-bottom: 10px;
        padding-bottom: 10px;
    }

    .question-container:last-child {
        border-bottom: none;
    }

    input{
        pointer-events: none;
    }
    .form-check-input {
        border: 1px solid #e95626 !important;
        width: 24px;
        height: 22px;
        position: relative;
        left: 1px;
        background-color: transparent !important;
    }

    .form-check-input:checked {
        background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e") !important;
        border: 2px solid var(--border-color-data-table) !important;
        background-color: #e95626 !important;
        box-shadow: 0 0 0 1px #e95626 !important;
    }
</style>